import React from "react";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import { privacyCMetaData } from "../seo/metaDeta";

const PrivacyPolicyCustomer = () => {
  return (
    <>
      <HelmetWrapper {...privacyCMetaData} />
      <main>
        <div className="container">
          <p>
            <h3>Privacy Policy (Customers)</h3>
          </p>
          <p>
            <span>Date of the policy: 11th Sep 2022</span>
          </p>
          <p>
            <span></span>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </p>
          <p>
            <span>
              Your privacy is of highest importance to us. We are Datazip
              Technologies Private Limited. (&ldquo;
            </span>
            <span>Datazip</span>
            <span>&rdquo;, &ldquo;</span>
            <span>us</span>
            <span>&rdquo; or &ldquo;</span>
            <span>
              we &rdquo;) are a Bengaluru, India based Private Limited Company,
              engaged in the business of providing a Software as a Service
              (SaaS) data platform, tools, including data ingestion, storage,
              processing, analytics and related services to our customers (the
              &ldquo;
            </span>
            <span>Service(s)</span>
            <span>&rdquo;).</span>
          </p>
          <p></p>
          <p>
            <span>This Privacy Policy (&quot;</span>
            <span>Policy</span>
            <span>
              &quot;) explains how we collect, use, disclose, protect and
              otherwise process our customers&rsquo; representatives&rsquo;
              (&quot;
            </span>
            <span>you</span>
            <span>&quot; or &quot;</span>
            <span>your</span>
            <span>&quot; or &quot;</span>
            <span>User</span>
            <span>
              &quot;) Personal Information (as defined below) that we may
              collect on the website (and subdomains) (
            </span>
            <span>
              <a href="https://www.google.com/url?q=https://datazip.io&amp;sa=D&amp;source=editors&amp;ust=1662880588348615&amp;usg=AOvVaw0F2zDKCVm5pFBaZL2U0sjm">
                https://datazip.io
              </a>
            </span>
            <span>, </span>
            <span>
              <a href="/blog">https://datazip.io/blog</a>
            </span>
            <span>, </span>
            <span>
              <a href="https://www.google.com/url?q=https://datatribe.datazip.io&amp;sa=D&amp;source=editors&amp;ust=1662880588349266&amp;usg=AOvVaw3QpXT577yIOhd86UMDkbW8">
                https://datatribe.datazip.io
              </a>
            </span>
            <span>), </span>
            <span>
              <a href="https://www.google.com/url?q=https://auth.datazip.io&amp;sa=D&amp;source=editors&amp;ust=1662880588349549&amp;usg=AOvVaw0FR_HDpQWkp0HkGyQPhneb">
                https://auth.datazip.io
              </a>
            </span>
            <span>, (</span>
            <span>&quot;Website&quot; or &quot;Site&quot;</span>
            <span>) </span>
            <span>
              &nbsp;&amp; through our SaaS platform that we deploy on your cloud
              provider (
            </span>
            <span>&quot;Datazip Application or Application&quot;</span>
            <span>
              ). We also provide information regarding how you can access and
              update your Personal Information and make certain choices about
              how your Personal Information is used by us. We also provide
              information on the non-Personal Information that we may collect
              such as cookies and log files, and our practices regarding such
              information.
            </span>
          </p>
          <p>
            <span>
              This Policy is applicable when you are a register, subscribe for
              our Services on the Site or are an already existing subscriber, or
              a free or pilot or paid customer having our service deployed on
              your cloud provider.
            </span>
          </p>
          <p></p>
          <p>
            <span>
              Please read this Policy carefully to understand our views and
              practices regarding your Personal Information and how we will
              treat it.{" "}
            </span>
            <span>
              If you reside in California, then this Policy is supplemented by
              our California Privacy Notice, which provides a privacy notice in
              accordance with the requirements of CCPA (defined below).
            </span>
          </p>
          <p></p>
          <p>
            <span>
              In accordance with applicable laws and regulations, including the
              European Union General Data Protection Regulation (EC Regulation
              2016/679) (&ldquo;
            </span>
            <span>GDPR</span>
            <span>
              &rdquo;), Datazip controls, owns and directs the use of the
              Personal Information collected on the Site and, in this regard,
              Datazip is the data controller.
            </span>
          </p>
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <p>
            <span></span>
          </p>
          <p>
            <h4>
              <span>Contact Us</span>
            </h4>
          </p>
          <p></p>
          <p>
            <span>
              For any queries regarding this Policy and the collection and use
              of Personal Information collected or processed under this Policy,
              you can write to our Data Protection Officer (Sandeep Devarapalli)
              by e-mail privacy@datazip.io or by post at{" "}
            </span>
            <span class="c7">Datazip Technologies Private Limited, </span>
            <span class="c3">
              #677, 1st Floor, Suite No.1303, 27th Main, 13th Cross, HSR Layout,
              Sector 1, Bangalore, Karnataka, India 560102
            </span>
          </p>
          <p class="c21 c13">
            <span class="c19 c26 c7"></span>
          </p>
          <p>
            <span>
              <span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <h4>
                1. What do we mean by Personal Information (&ldquo;Personal
                Information&rdquo;)?
              </h4>
            </span>
          </p>
          <p></p>
          <p>
            <span>
              In this Policy, Personal Information means information or an
              information set that identifies or could be used to identify an
              individual. Datazip collects Personal Information as set out in
              Section 2 and 3 of this Policy from Users.
            </span>
          </p>
          <p></p>
          <p>
            <span>
              Personal Information does not include &ldquo;Usage Data&rdquo;
              which we define as encoded or anonymized information or aggregated
              data we collect about a group or category of services, features or
              Users which does not contain personally identifying information.
              Usage Data helps us understand trends in usage of the Service so
              that we can better consider new features or otherwise tailor the
              Service. In addition to collecting and using Usage Data ourselves,
              we may share Usage Data with third parties, including our partners
              and service providers, for various purposes, including to help us
              better understand our customers&rsquo; needs and improve the
              Service as well as for advertising and marketing purposes. Such
              Usage Data is always stored in encrypted form, and in no event can
              any person who has access to the Usage Data be able to use or
              modify the Usage Data in a way such that it may become Personal
              Information, or can be used to identify a person.
            </span>
          </p>
          <p>
            <span></span>
          </p>
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <p>
            <h4>
              <span>2. What information do we process ?</span>
            </h4>
          </p>
          <p></p>
          <p>
            <span>
              We process the following types of information to provide you the
              Services.
            </span>
          </p>
          <p></p>
          <p class="c21 c13">
            <span class="c3"></span>
          </p>
          <p class="c21 c13">
            <span class="c3"></span>
          </p>
          <p class="c21 c13">
            <span class="c19 c26 c7"></span>
          </p>
          <p class="c21 c13">
            <span class="c19 c26 c7"></span>
          </p>
          <p class="c13 c21">
            <span class="c19 c26 c7"></span>
          </p>
          {/* <a id="t.044ede302f5f3f6c533308c67fc05d2a60fd34cc"></a> */}
          {/* <a id="t.0"></a> */}
          <table class="c31">
            <tr class="c11">
              <td class="c5" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c19 c33 c7">Sr. No</span>
                </p>
              </td>
              <td class="c28" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c19 c33 c7">Category of information</span>
                </p>
              </td>
              <td class="c14" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c19 c33 c7">Description</span>
                </p>
              </td>
            </tr>
            <tr class="c11">
              <td class="c5" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c3">1</span>
                </p>
              </td>
              <td class="c28" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c3">Customer Identification Data</span>
                </p>
              </td>
              <td class="c14" colspan="1" rowspan="1">
                <p class="c15">
                  <span>
                    Customer Identification Data means the Personal Information
                    provided by you, on our request, at the time of signing up
                    for the Services, whether through the website https://
                  </span>
                  <span>
                    <a
                      class="c24"
                      href="https://www.google.com/url?q=https://hevodata.com/&amp;sa=D&amp;source=editors&amp;ust=1662880588354214&amp;usg=AOvVaw3oc3lNspusg9G0EPbBXQob"
                    >
                      datazip.io
                    </a>
                  </span>
                  <span class="c3">&nbsp;or through an agreement.</span>
                </p>
              </td>
            </tr>
            <tr class="c37">
              <td class="c5" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c3">2</span>
                </p>
              </td>
              <td class="c28" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c3">Customer Personal Data</span>
                </p>
              </td>
              <td class="c14" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c3">
                    Customer Personal Data means Personal Information processed
                    or stored by or on your behalf during your use of the
                    Services. Customer Personal Data excludes any Customer
                    Identification Data, which is primarily processed or stored
                    by us.
                  </span>
                </p>
                <p class="c15">
                  <span>
                    This Policy does not apply to Customer Data. For more
                    information on how we process the Customer Data, please
                    refer to the Data Processin
                  </span>
                  <span class="c34">g Addendum, which</span>
                  <span class="c3">
                    &nbsp;details our role as the data processor and your rights
                    as the data controller during your use of the Service.
                  </span>
                </p>
              </td>
            </tr>
            <tr class="c22">
              <td class="c5" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c3">3</span>
                </p>
              </td>
              <td class="c28" colspan="1" rowspan="1">
                <p class="c15">
                  <span class="c3">Payments Data</span>
                </p>
              </td>
              <td class="c14" colspan="1" rowspan="1">
                <p class="c15">
                  <span>
                    When you register for the Service on the Site, you will be
                    directed to our third-party payment gateway services p
                  </span>
                  <span class="c34">
                    rovider, Stripe &amp; IDFC First Bank, which will collect
                    certain credit card or other billing information to enabl
                  </span>
                  <span class="c3">
                    e you to make the payment for the Service. Please read the
                    privacy policy of such third-party service providers. We
                    receive your billing name, address and other transaction
                    details from the payment gateway service provider.
                  </span>
                </p>
              </td>
            </tr>
            <tr class="c11">
              <td class="c5" colspan="1" rowspan="1">
                <p class="c27">
                  <span class="c3">4</span>
                </p>
              </td>
              <td class="c28" colspan="1" rowspan="1">
                <p class="c27">
                  <span class="c3">Settings and configurations Data</span>
                </p>
              </td>
              <td class="c14" colspan="1" rowspan="1">
                <p class="c27">
                  <span class="c3">
                    We record your configuration and settings-related data. This
                    includes information relating to your choices and
                    preferences of using our Site.
                  </span>
                </p>
              </td>
            </tr>
            <tr class="c11">
              <td class="c5" colspan="1" rowspan="1">
                <p class="c27">
                  <span class="c3">5</span>
                </p>
              </td>
              <td class="c28" colspan="1" rowspan="1">
                <p class="c27">
                  <span class="c3">Communications Data</span>
                </p>
              </td>
              <td class="c14" colspan="1" rowspan="1">
                <p class="c27">
                  <span class="c3">
                    We keep records of your communications and interactions with
                    us, through email, chat messages, telephone or other modes.
                    This includes instances when you provide feedback or seek
                    technical support from us.
                  </span>
                </p>
              </td>
            </tr>
            <tr class="c30">
              <td class="c5" colspan="1" rowspan="1">
                <p class="c27">
                  <span class="c3">6</span>
                </p>
              </td>
              <td class="c28" colspan="1" rowspan="1">
                <p class="c27">
                  <span class="c3">App Credentials</span>
                </p>
              </td>
              <td class="c14" colspan="1" rowspan="1">
                <p>
                  <span>
                    We do not store certain information such as your login
                    identification details. We only play a role in transferring
                    certain access tokens from different third party
                    applications (Received after you give permission by signing
                    into that third party application via Oauth/Oauth2
                    identification mechanism) to Datazip Application. Please
                    refer to Section 13.1 for more details.
                  </span>
                </p>
              </td>
            </tr>
          </table>
          <p>
            <span></span>
          </p>
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <p>
            <h4>
              <span>3. Legal basis for Processing of Personal Information</span>
            </h4>
          </p>
          <p></p>
          <p>
            <span>
              The legal basis for the collection and processing of any Personal
              Information collected and processed by us is: (i) for the
              performance of the Services in accordance with the contract
              executed with you or in accordance with our Terms of Use; or (ii)
              where it is in our legitimate interests to do so and such
              legitimate interest is not overridden by your rights, (as
              specified in Section 10 below, for example to do internal research
              on our Users&#39; usage, including, without limitation,
              demographics, interests, patterns, and behavior to better
              understand, protect, and serve our Users, while improving our Site
              and Services). This information is compiled and analyzed on an
              aggregated basis.
            </span>
          </p>
          <p>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </p>
          <h4>
            <span>4.1 Information You Provide to us</span>
          </h4>
          <p>
            <span>
              When you register for the Service on the Site, we ask for certain
              Personal Information comprising &lsquo;customer identification
              data&rsquo; which includes, but is not limited to:
            </span>
          </p>
          <ol>
            <li>
              <span>your name,</span>
            </li>
            <li>
              <span>e-mail address,</span>
            </li>
            <li>
              <span>phone number,</span>
            </li>
            <li>
              <span>
                certain related information like your company name and job role,
                if applicable, and website name;
              </span>
            </li>
          </ol>
          <p>
            <span>
              Additionally, when you register for the Service on the Site, you
              will be directed to our third-party payment gateway services
              provider, Stripe or IDFC First, which will collect certain credit
              card or other billing information to enable you to make the
              payment for the Service. Please read the privacy policy of such
              third-party service provider.
            </span>
          </p>
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <h4>
            <span>4.2 Information We May Receive from Third Parties</span>
          </h4>
          <p>
            <span>
              When you become a customer of Datazip and deploy the Datazip
              Application
            </span>
            <span>
              , we may receive Personal Information about you from third parties
              through authorization that you may have provided to the third
              party for sharing such information with us. For example, if you
              connect a third party application to Datazip Application, that
              third party you connected with may pass certain information about
              your use of its service to Datazip.
            </span>
          </p>
          <p>
            <span>
              This information could include, but is not limited to, the user ID
              associated with your account, an access token necessary to access
              that service, and any information you have made public in
              connection with that third-party service. You should always
              review, and if necessary, adjust your privacy settings on third
              party websites and services before linking or connecting them to
              the Service.
            </span>
          </p>
          <p>
            <span>
              Any information that you have permitted the third party to share
              with us, will only be fetched by Datazip Application and stored in
              your cloud provider only. We are not storing any of this
              information in the Datazip systems outside your cloud provider.
            </span>
          </p>
          <h4>
            <span>
              4.3 Information we generate while providing you Services:
            </span>
          </h4>
          <p>
            <span>
              We use third party analytics tools to help us measure traffic and
              usage trends for the Site and Datazip Application. These tools
              collect information sent by your browser while you are on the Site
              or using our Datazip Application, that assists us in improving the
              Service.
            </span>
          </p>
          <p>
            <span>
              Note that we will never email you to ask for your Datazip account
              information; if you receive such an email, please forward it to
              privacy@datazip.io. Datazip may use your cell phone number to call
              or text you in order to provide the Service, if you have provided
              consent to Datazip for such communication. You may opt-out of this
              communication at any time by writing in to{" "}
            </span>
            <span>
              <a href="mailto:privacy@datazip.io">privacy@datazip.io</a>
            </span>
            <span>.</span>
          </p>
          <p>
            <span></span>
          </p>
          <h4 id="h.f66h8p7j41av">
            <span>5. Processing of Personal Information</span>
          </h4>
          <p>
            <span>
              We rely on our underlying contract (whether through the Terms of
              Use, or the agreement entered into between you and Datazip) for
              the processing of Personal Information for the following purposes:
            </span>
          </p>
          <ol>
            <li>
              <span>Provision of Services:</span>
              <span>
                &nbsp;We may use the Personal Information to operate, and
                personalize the Service for you. We may also use the Personal
                Information for billing identification and authentication, to
                contact and communicate with you about the Service and you
              </span>
              <span>r</span>
              <span>&nbsp;</span>
              <span>
                use of the Service, and to support your use of the Service.
                Where it is in our legitimate interests to do so, we use the
                Personal Information collected by us for various purposes to
                enable us to serve you better.
              </span>
            </li>
            <li>
              <span>Marketing Communication:</span>
              <span>
                &nbsp;We may use the Personal Information to send you marketing
                material if you register for our Service on the Site, or sign up
                on the Site to receive marketing communication (subject to your
                opt-out option).
              </span>
            </li>
            <li>
              <span>Site, Datazip Application and Service Improvement:</span>
              <span>
                &nbsp;We may use Personal Information to improve upon your use
                of the Service, and to generally improve the content and
                functionality of the Service.
              </span>
            </li>
            <li>
              <span>Fraud Prevention and Troubleshooting:</span>
              <span>
                &nbsp;Additionally, we may use the Personal Information we
                collect for identification and authentication and fraud
                prevention, troubleshooting problems on the Site, Datazip
                Application and Service.
              </span>
            </li>
            <li>
              <span>Analytics Operations:</span>
              <span>
                &nbsp;We may collect and use analytics information together with
                your Personal Information to build a broader profile of our
                individual Users so that we can serve you better and provide
                custom, personalized content and information.
              </span>
            </li>
            <li>
              <span>Legal Obligations:</span>
              <span>
                &nbsp;In some cases, we may need to process the Personal
                Information about you, where we need to comply with a legal
                requirement.
              </span>
            </li>
          </ol>
          <p>
            <span>
              While collecting Personal Information, we indicate fields that are
              mandatory and those that are optional. You may decide whether or
              not to provide such optional information to us. However,
              non-provision of mandatory information may result in us being
              unable to provide the Services to you. Further, non-provision of
              specific or accurate Personal Information may result in a
              disruption in your usage of our Site, Datazip Application or the
              Services, for which we will not be responsible.
            </span>
          </p>
          <h4>
            <span>6. Disclosure of Personal Information</span>
          </h4>
          <p>
            <span>
              When you access or use the Site, Datazip Application or the
              Service, or otherwise provide information to us, you are
              consenting to the sharing of such information with Datazip&rsquo;s
              related entities, third-party service providers and other
              entities. We may disclose your Personal Information in the
              following instances:
            </span>
          </p>
          <ol>
            <li>
              <span>For provision of the Service:</span>
              <span>
                <br />
              </span>
              <span>
                We may disclose Personal Information to our third-party service
                providers (such as its credit card processors and hosting
                partners) to provide the necessary hardware, software,
                networking, storage, and other services we use to operate the
                Service and maintain a high-quality user experience. We do not
                permit our service providers to use the Personal Information we
                share for their marketing purposes.
              </span>
            </li>
            <li>
              <span>
                For maintenance and improvement of the Site and Services:
              </span>
              <span>
                <br />
              </span>
              <span>
                We may also disclose Personal Information with our third-party
                service providers for purposes of improvement and maintenance of
                our Site, Datazip Application and Services, and in order to
                customize Users&rsquo; experiences.
              </span>
            </li>
            <li>
              <span>For fulfilling our legal obligations:</span>
              <span>
                <br />
              </span>
              <span>
                We may disclose Personal Information to respond to subpoenas,
                court orders, on legal process, or to establish or exercise our
                legal rights or defend against legal claims, provided that we
                will intimate you, if not prohibited under law, as soon as
                reasonably possible if your Personal Information is shared for
                such purpose.
              </span>
            </li>
            <li>
              <span>For fraud prevention and troubleshooting:</span>
              <span>
                <br />
              </span>
              <span>
                We may also share such information with the relevant third party
                if we believe it is necessary in order to investigate, prevent,
                or take action regarding illegal activities, suspected fraud,
                situations involving potential threats to the physical safety of
                any person, violations or our Terms of Service.
              </span>
            </li>
            <li>
              <span>To members of the Datazip family:</span>
              <span>
                <br />
              </span>
              <span>
                We may also share information, including Personal Information
                with any member of the Datazip family which includes any entity
                that controls, is controlled by, or under common control with
                Datazip, in order to provide you with the Service.
              </span>
            </li>
            <li>
              <span>Third Party Applications:</span>
              <span>
                <br />
              </span>
              <span>
                The following table enlists the third-party applications that we
                may share your information with and the purpose for which such
                information is shared:
              </span>
            </li>
          </ol>
          {/* <a id="t.e28b550bab028658d297744f1601d1b54ae38f3e"></a> */}
          {/* <a id="t.1"></a> */}
          <table class="c31">
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c35 c34">
                  <span class="c19 c7 c33">Third Party Application</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c34 c35">
                  <span class="c19 c33 c7">Purpose</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Zapier</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Workflow Automation</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Reply.io</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Sending emails</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Hubspot</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">CRM</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Calendly</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Set up meetings</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Retently</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Collect feedback</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Front App</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Sending emails</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Clearbit</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Data enrichment</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Gsuite/Google Drive</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">
                    Emails, document creation &amp; storage
                  </span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Upvoty</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">User Feedback</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Zendesk</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Support Tickets</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Intercom</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Support Tickets</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Fullstory</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">User Behaviour Tracking</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Instapage</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Customer Landing Pages</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Mailchimp</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Marketing Automation</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Mixpanel</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">User Behaviour Tracking</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Stripe</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Payments and Billing</span>
                </p>
              </td>
            </tr>
            <tr class="c16">
              <td class="c17" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Slack</span>
                </p>
              </td>
              <td class="c1" colspan="1" rowspan="1">
                <p class="c2">
                  <span class="c3">Alerts</span>
                </p>
              </td>
            </tr>
          </table>
          <h4 class="c12 c25" id="h.wa2h6lp7p6ai">
            <span></span>
          </h4>
          <h4>
            <span>7. Hosting and Data Transfer</span>
          </h4>
          <p>
            <span>
              We host &amp; transfer information in the same region that the
              customer wants to get Datazip Application deployed.{" "}
            </span>
            <span>
              We are based in India &amp; process Personal Information, in India
              and in other countries through Datazip Site and third parties that
              we use to operate and manage the Service, provided that we shall
              ensure that your Personal Information shall be protected in
              accordance with this Policy.
            </span>
          </p>
          <p>
            <span>
              These countries may have data protection laws that are different
              from the laws of your country. When we transfer Personal
              Information outside of your country, we will ensure that
              appropriate safeguards are in place to ensure that your Personal
              Information will remain protected in accordance with this Policy.
              For instance, in order to transfer Personal Information to third
              parties outside of the European Economic Area, we may enter into
              Standard Contractual Clauses to ensure that such transfer is in
              compliance with the GDPR.
            </span>
          </p>
          <p>
            <span>
              When you access or use the Site, or otherwise provide information
              to us, you are consenting to the processing and transfer of
              personal information in and to India and other countries which may
              have different privacy laws from your or their country of
              residence.
            </span>
          </p>
          <p>
            <span>
              When you use a Datazip Application or the Service, the data that
              you ingest, process, analyse is going to remain in the region
              where you have agreed to host it &amp; based on the cloud provider
              that you use.
            </span>
          </p>
          <h4>
            <span>8. Storage and Security of Personal Information</span>
          </h4>
          <p>
            <span>
              All your Personal Information is stored on the Amazon Web Services
              (AWS) cloud, which is restricted and highly secured with the
              necessary firewalls. A copy of the privacy practices applicable to
              storage of information on AWS&rsquo; servers is available at{" "}
            </span>
            <span>
              <a href="https://www.google.com/url?q=https://aws.amazon.com/privacy/&amp;sa=D&amp;source=editors&amp;ust=1662880588374866&amp;usg=AOvVaw0MKVkuQzDpu4mkSDpLBYTj">
                https://aws.amazon.com/privacy/.
              </a>
            </span>
          </p>
          <p>
            <span>
              We process the Personal Information collected in a lawful and
              proper manner and take appropriate security measures to prevent
              unauthorized access, disclosure, modification or unauthorized
              destruction of the Personal Information. While Datazip will use
              commercially reasonable efforts and in accordance with applicable
              law, to ensure the security of all Personal Information, we
              expressly disclaim any liability for any unauthorized access to or
              use of third-party servers and/or any and all personal and/or
              financial information stored therein if such access or use has
              been done despite Datazip employing all commercially reasonable
              efforts and in accordance with applicable law.
            </span>
          </p>
          <p>
            <span>
              We take appropriate security measures to protect against
              unauthorized access to or unauthorized alteration, disclosure, or
              destruction of Personal Information. These include
            </span>
            <span>:</span>
          </p>
          <ul>
            <li>
              <span>
                internal reviews of our data collection and processing practices
                and security measures.
              </span>
            </li>
            <li>
              <span>
                We restrict access to Personal Information to our employees,
                contractors, and agents who require or need to know that
                information in order to operate, develop, or improve our
                Services. These individuals are contractually bound by
                confidentiality obligations and may be subject to disciplinary
                measures, if they fail to meet these obligations.
              </span>
            </li>
            <li>
              <span>
                employing industry-wide, commercially reasonable technological,
                physical and administrative security safeguards, such as: (i)
                firewalls and carefully-developed security procedures; (ii)
                ensuring ongoing confidentiality, integrity, availability and
                resilience or processing systems and services; and (iii) regular
                testing, assessment and evaluation of the effectiveness of our
                technical and organizational measures to ensure your Personal
                Information is secure. For example, when you enter confidential
                information (such as login credentials or information submitted
                from within the Service) we encrypt the transmission of that
                information using secure socket layer technology (SSL). These
                technologies, procedures and other measures are used in an
                effort to ensure that your data is safe, secure, and only
                available to you and to those you authorized to access your
                data.
              </span>
            </li>
          </ul>
          <p>
            <span>
              However, no internet, e-mail or other electronic transmission is
              ever fully secure or error free, so you should take care in
              deciding what information you send to us in this way. Datazip is
              not responsible for the functionality or security measures of any
              third party
            </span>
            <span>.</span>
          </p>
          <h4>
            <span>
              9. Non-Personal Information that we collect: Log Files, Cookies
              and Clear gifs
            </span>
          </h4>
          <p>
            <span>
              We process certain non-Personal Information, as provided below. In
              certain situations, such non-Personal Information may be used in
              conjunction with Personal Information
            </span>
            <span>.</span>
          </p>
          <h4>
            <span>9.1 Log Files</span>
          </h4>
          <p>
            <span>Datazip</span>
            <span>
              &nbsp;gathers certain information automatically and stores it in
              log files. This information includes internet protocol addresses
              as well as browser, Datazip Application generated system &amp;
              monitoring logs (Containing non-personal information),
              &nbsp;internet service provider, referring/exit pages, search
              terms, operating system, date/time stamp, and clickstream data.
              Occasionally, we may{" "}
            </span>
            <span>connect</span>
            <span>
              &nbsp;Personal Information (Only account details you provide us on
              Datazip Website) to information gathered in our log files, as
              necessary to improve the Service for individual customers.
              Otherwise, we generally use this information as we would any usage
              Data, to analyze trends, administer and maintain the Service,
              billing, or track usage of various features within the Service.
            </span>
          </p>
          <h4>
            <span>9.2 Cookies</span>
          </h4>
          <p>
            <span>
              A cookie is a small software file stored temporarily or placed on
              your computer&rsquo;s hard drive. The main purpose of a cookie is
              to allow a web server to identify a user&rsquo;s computer and web
              browser, and tailor web pages and/or login information to such
              user&rsquo;s preferences.
            </span>
          </p>
          <p>
            <span>
              Cookies in our current use case are only used when you use Datazip
              Site &amp; will be used to transfer third party access tokens or
              improve certain parts of Datazip Site. Cookies don&rsquo;t give us
              access to your computers. We might collect Datazip Application
              cookies information for the purpose of improving service or user
              experience for a particular role using it. The information
              won&rsquo;t be used to identify you personally and use it for
              marketing or any other purpose.
            </span>
          </p>
          <p>
            <span>
              We utilize session cookies, which allow us to uniquely identify
              your browser while you are logged in and to process your online
              transactions. Session cookies disappear from your computer when
              the web browser is closed or the computer is turned off. We also
              utilize persistent cookies to make it easier to log into and use
              the Service. Persistent cookies remain on computers after the web
              browser is closed or the computer is turned off.
            </span>
          </p>
          <p>
            <span>
              We use or may use cookies to: (a) provide custom, personalized
              content and information; (b) monitor aggregate metrics such as
              total number of visitors, traffic, and demographic patterns; and
              (c) to provide advertising to your browser or device (This is only
              for Datazip Site).
            </span>
          </p>
          <p>
            <span>
              You are always free to disable our cookies at any time by using
              your browser options, however if you turn off cookies you may not
              be able to use certain features on the Site or in respect of the
              Services, for which, we shall not be responsible. Additionally,
              you may encounter &quot;cookies&quot; or other similar devices on
              certain pages of our Site, Datazip Application or our Service that
              are placed by third parties
            </span>
            <span>.</span>
          </p>
          <p>
            <span>
              If you require more specific information as to the nature of the
              cookies utilized in the Service for purposes of fulfilling these
              obligations, please contact us by email at{" "}
            </span>
            <span>
              <a href="mailto:privacy@datazip.io">privacy@datazip.io</a>
            </span>
            <span>.</span>
          </p>
          <p>
            <span></span>
          </p>
          <p>
            <span></span>
          </p>
          <h4>
            <span>10 Individual Rights:</span>
          </h4>
          <h4>
            <span>10.1 European Union Requirements:</span>
          </h4>
          <p>
            <span>
              If you reside in European Economic Area, you have the following
              rights in relation to the Personal Information:
            </span>
          </p>
          <ol>
            <li>
              <span>
                you will, at all times, have access to your Personal
                Information;
              </span>
            </li>
            <li>
              <span>
                be informed about the Personal Information we collect from you
                and use;
              </span>
            </li>
            <li>
              <span>
                obtain confirmation from us that Your Personal Information is
                being collected and used by us;
              </span>
            </li>
            <li>
              <span>
                can ask us to rectify information, which you think is
                inaccurate;
              </span>
            </li>
            <li>
              <span>
                erasure, or the right to be forgotten, which means you can
                request the deletion or removal of any Personal Information we
                hold about you at any time;
              </span>
            </li>
            <li>
              <span>
                block or suppress us from collecting and using your Personal
                Information, which means we can continue to store your Personal
                Information but we cannot further collect or use it in any way;
              </span>
            </li>
            <li>
              <span>
                obtain and reuse any Personal Information we hold about you for
                your own purposes across different services, which allows you to
                move, copy or transfer your Personal Information easily from
                Datazip to another place notified by you to us in a safe and
                secure way without hindrance to the usability of your Personal
                Information; and
              </span>
            </li>
            <li>
              <span>
                object or restrict the processing of your Personal Information
              </span>
              <span>.</span>
            </li>
          </ol>
          <h4>
            <span>10.2 United Kingdom Requirements:</span>
          </h4>
          <p>
            <span>
              If you reside in the United Kingdom, you have the rights listed in
              section 10.1. In addition, you can lodge a complaint with the
              Information Commissioner&rsquo;s Office (&ldquo;ICO&rdquo;), if
              you are unhappy with the way in which your Personal Information is
              handled. You can reach out to the ICO at Information
              Commissioner&rsquo;s Office, Wycliffe House, Water Lane, Wilmslow,
              Cheshire SK9 5AF or on its website at https://ico.org.uk/ or call
              them at 0303 123 1113.
            </span>
          </p>
          <h4>
            <span>10.3 California Requirements:</span>
          </h4>
          <p>
            <span>
              If you reside in California (United States), you may have the
              following rights in relation to Personal Information:
            </span>
          </p>
          <ol>
            <li>
              <span>Right to Know</span>
              <span>:</span>
              <span>
                &nbsp;You have the right to ask us to disclose the Personal
                Information we have collected, used, shared or sold about you.
              </span>
            </li>
            <li>
              <span>Right to Delete:</span>
              <span>
                &nbsp;You have the right to ask us to delete your Personal
                Information in certain circumstances.
              </span>
            </li>
            <li>
              <span>Right to Opt-out: </span>
              <span>
                You have the right to ask us to stop selling your Personal
                Information. But we don&rsquo;t sell your Personal Information.
              </span>
            </li>
            <li>
              <span>Right to Non-Discrimination</span>
              <span>:</span>
              <span>
                &nbsp;We will not discriminate against you in the event you
                exercise your rights. However, in certain circumstances,
                exercising your rights may affect our ability to provide you the
                Services
              </span>
              <span>.</span>
            </li>
          </ol>
          <h4>
            <span>10.4 Exercise of Rights:</span>
          </h4>
          <p>
            <span>
              In order to exercise any of your rights in relation to your
              Personal Information, you may send us an email at{" "}
            </span>
            <span>privacy@datazip.io</span>
            <span>
              &nbsp;detailing your request. Provided that, in such
              circumstances, the Services we provide you may be adversely
              affected as a result of such correction or deletion, and we shall
              not be responsible for such adverse effects or disruptions.
            </span>
          </p>
          <p>
            <span>
              We will aim to respond to all legitimate requests within one month
              of receipt of your request. Occasionally it may take us longer
              than one month if your request is particularly complex or if you
              have made a number of requests. In this case, we will notify you
              and keep you updated.
            </span>
          </p>
          <p>
            <span>
              We may need to request specific information from you to help us
              confirm your identity and to allow you to exercise any of your
              rights. This is a security measure to ensure the safety of your
              Personal Information. We may also contact you to ask you for
              further information in relation to your request to speed up our
              response.
            </span>
          </p>
          <h4>
            <span>10.5 Withdrawal of Consent:</span>
          </h4>
          <p>
            <span>
              You may decline to submit any Personal Information through the
              Site or withdraw your consent under this Policy at any time, in
              which case we may not be able to provide Services to you.
            </span>
          </p>
          <p>
            <span>
              If you would like to opt-out of getting communications from
              Datazip please contact us at{" "}
            </span>
            <span>privacy@datazip.io</span>
            <span>
              &nbsp;or follow the unsubscribe instructions included in such
              communications.
            </span>
          </p>
          <p>
            <span>
              Requests to opt-out of transfers to our third-party vendors may
              also be submitted, but limitations on data sharing may make it
              difficult or impossible to provide the Service after an opt-out.
            </span>
          </p>
          <h4>
            <span>10.6 Concerns:</span>
          </h4>
          <p>
            <span>
              If you have any concerns about the use of your Personal
              Information, you can write to our Data Protection Officer (Sandeep
              Devarapalli) by email at{" "}
            </span>
            <span>privacy@datazip.io</span>
            <span>
              &nbsp;detailing your concern. You can also contact your local data
              protection authority if you have any concerns regarding your
              rights under local law.
            </span>
          </p>
          <h4>
            <span>11. Data Retention</span>
          </h4>
          <p>
            <span>
              Datazip will retain Personal Information we collect directly from
              Users for as long as needed to provide the Service to our
              customers, subject to our compliance with this Policy.
            </span>
          </p>
          <p>
            <span>
              We may further retain and use this Personal Information as
              necessary only to comply with our legal obligations, maintain
              accurate accounting, financial and other operational records,
              resolve disputes, and enforce our agreements. We have established
              internal policies for the deletion of data from customer accounts
              following termination of a customer&rsquo;s subscription to the
              Service.
            </span>
          </p>
          <h4>
            <span>
              12. Correcting and Updating of your Information and exercise of
              rights:
            </span>
          </h4>
          <p>
            <span>
              It is important that the Personal Information we hold about you is
              accurate and current. Please keep us informed if your Personal
              Information changes during your relationship with us.
            </span>
          </p>
          <p>
            <span>
              In the event that you would like to access, correct, delete or
              object to any inaccuracies of the Personal Information provided by
              you, please follow the mechanism provided in Section 10.4 to
              exercise such rights.
            </span>
          </p>
          <h4>
            <span>13. Other Information about our Privacy Practices</span>
          </h4>
          <h4>
            <span>13.1 Data Integration:</span>
          </h4>
          <p>
            <span>
              Only place where information related to Third party app
              credentials (Ex, Access Tokens/Refresh Tokens &amp; others) are
              stored in Datazip Application in encrypted form. We do not store
              any copy of these credentials outside of Datazip Application and
              would not have access to it as Datazip Application runs in client
              VPC/Private Network.
            </span>
          </p>
          <p>
            <span>
              When we access these third-party applications on your behalf, the
              third-party application provides us with access to certain data.
              We will only transfer this data to Datazip Application deployed in
              your cloud provider but do not store it outside of the Datazip
              Application Network which is your private network.
            </span>
          </p>
          <p>
            <span>
              Datazip shall have no liability or responsibility for the privacy
              practices or other actions of any third-party applications for
              which you provide us with App Credentials. We suggest that you
              review the privacy policies of the third parties prior to using
              the third-party platforms.
            </span>
          </p>
          <h4>
            <span>13.2 Links to Other Websites</span>
          </h4>
          <p>
            <span>
              The Site &amp; Application might contain links to websites and
              applications other than the Site, including websites and
              applications operated by affiliates and other third parties.
              Please be aware that we do not determine and we are not
              responsible for the privacy practices or content of websites and
              applications operated by third parties. Your browsing and
              interaction on any third-party website or service, including those
              that have a link on our Site, are subject to that third
              party&rsquo;s own rules and policies. We encourage you to be aware
              when you leave the Site, and read the privacy statements of such
              third-party websites and applications. Datazip does not endorse
              and is not responsible for the practices of third parties or their
              websites or applications. If you are using a third-party website
              or service and you allow such a third-party access to your
              Personal Information, you do so at your own risk.
            </span>
          </p>
          <h4>
            <span>13.3 Do Not Track</span>
          </h4>
          <p>
            <span>
              We do not track or respond to browser &ldquo;Do Not Track&rdquo;
              Requests. A user will have to disable cookies in order that no
              information is tracked.
            </span>
          </p>
          <h4>
            <span>13.4 Public Forums</span>
          </h4>
          <p>
            <span>
              The Site or Service offers publicly-accessible blogs or community
              forums. You should be aware that any information provided in these
              areas may be read, collected, and used by others who access them.
              If you elect to post something in a public area of our Site,
              Datazip Application or Service, any Personal Information or
              content that you voluntarily disclose for posting to the Site,
              Datazip Application or Service, becomes available to the public,
              as controlled by any applicable privacy settings. If you remove
              information that you posted to the Site, Datazip Application or
              Service, copies may remain viewable in cached and archived pages
              of the Service, or if other Users have copied or saved that
              information. To request removal of your Personal Information from
              our blog or community, contact us at{" "}
            </span>
            <span>
              <a href="mailto:privacy@datazip.io">privacy@datazip.io</a>
            </span>
            <span>
              . In some cases, we may not be able to remove your Personal
              Information.
            </span>
          </p>
          <h4>
            <span>13.5 Customer Testimonials/ Comments/ Reviews</span>
          </h4>
          <p>
            <span>
              From time to time, we may post customer testimonials, reviews,
              case studies etc. on the Site which may contain Personal
              Information. We obtain the Users&rsquo; consent to post their
              names along with their testimonials.
            </span>
          </p>
          <h4>
            <span>13.6 Children&#39;s Personal Information</span>
          </h4>
          <p>
            <span>Datazip</span>
            <span>
              &nbsp;does not knowingly collect any Personal Information from
              children under the age of 16. If you are under the age of 16,
              please do not submit any Personal Information through our Site,
              Datazip Application or Service. We encourage parents and legal
              guardians to monitor their children&rsquo;s Internet usage and to
              help enforce our Policy by instructing their children never to
              provide Personal Information on our Site, Datazip Application or
              Service without their permission. If you have reason to believe
              that a child under the age of 13 has provided Personal Information
              to us through our Site, Datazip Application or Service, please
              contact us, and we will use commercially reasonable efforts to
              delete that information from our databases.
            </span>
          </p>
          <h4>
            <span>14. Changes to this Policy</span>
          </h4>
          <p>
            <span>
              We may, in our sole discretion, modify or update this Policy from
              time to time. If we make any material changes to this Policy, we
              will notify you by email or by posting a prominent notice on the
              Site prior to the change becoming effective. We encourage you to
              periodically review this page for the latest information on our
              privacy practices. Your continued use of the Service constitutes
              your agreement to be bound by such changes to this Policy. Your
              only remedy, if you do not accept the terms of this Policy, is to
              discontinue use of the Service.
            </span>
          </p>
          <h4>
            <span>15. Business Transactions</span>
          </h4>
          <p>
            <span>Datazip</span>
            <span>
              &nbsp;may assign or transfer this Policy, and your Personal
              Information, to any person or entity that acquires all or
              substantially all of the business, stock or assets of, or is
              merged with Datazip. We may also transfer or assign such
              information in the course of corporate divestitures, mergers,
              acquisitions, bankruptcies, dissolutions or similar transactions
              or proceedings, provided that the recipient of such information
              will continue to be bound by the terms of this Policy.
            </span>
          </p>
          <p>
            <span></span>
          </p>
        </div>
      </main>
    </>
  );
};

export default PrivacyPolicyCustomer;
